import { CheckCircle, Information } from '@patrianna-icons/material-icons'
import type { CardsVerificationsStatus } from '@patrianna-payments/shared-store/verifications/types/CardsVerificationsStatus'
import Link from 'next/link'

import RichText from 'src/components/RichText'

import classes from './styles.module.scss'

const verificationStatusIcons = {
  in_progress: <Information className={classes.inProgressIcon} />,
  verified: <CheckCircle className={classes.verifiedIcon} />,
  attempt_limit_reached: <Information className={classes.attentionIcon} />,
}

// TODO: move 'verification_failed' and '' to patrianna types
export const getVerificationStatusComponent = (
  verificationStatus: CardsVerificationsStatus | 'verification_failed' | '',
  t: (key: string, dynamicValues?: Record<string, string | number>) => any,
) => {
  switch (verificationStatus) {
    case 'verified': {
      return (
        <span className={classes.cardVerificationStatus}>
          {verificationStatusIcons[verificationStatus]}
          {t(verificationStatus)}
        </span>
      )
    }

    case 'attempt_limit_reached': {
      return (
        <span className={classes.cardVerificationStatus}>
          {verificationStatusIcons[verificationStatus]}
          <div>
            <RichText
              field={t('limit_reached_support')}
              components={{
                paragraph: ({ children }) => <>{children}</>,
                strong: ({ children }) => {
                  return <Link href={process.env.ZENDESK_SUPPORT_LINK}>{children}</Link>
                },
              }}
            />
          </div>
        </span>
      )
    }

    case 'in_progress':
    case 'verification_failed': {
      return (
        <span className={classes.cardVerificationStatus}>
          {verificationStatusIcons['in_progress']}
          {t('in_progress')}
        </span>
      )
    }

    default: {
      return null
    }
  }
}
